export const MAX_DOCUMENTS_DOWNLOAD = 5;

export function DownloadLimitInfo({ selectedCount, max = MAX_DOCUMENTS_DOWNLOAD }) {
  const isMax = selectedCount === max;
  const isOver = selectedCount > max;

  const color = isOver ? "#E83E8C" : "#000000de";
    
  const message = isOver
    ? " - Maximum documents for download exceeded"
    : isMax
    ? " - Maximum documents for download reached"
    : "";

  return (
    <div className="d-flex align-center justify-content-end gap-2 mb-1">
      <p
        className="mb-0"
        style={{
          fontSize: "14px",
          color,
        }}
      >
        <strong>
          {selectedCount}/{max}
        </strong>{" "}
        documents selected for download
        {message}
      </p>
    </div>
  );
}